module.exports = __webpack_public_path__ + "static/media/mobile-template.65cf250a.png";